<template>
  <div class="voucher-item inner-wrap">
    <div class="label-area">
      <h3>
        <span>{{ voucherTitle }}</span>
        <span v-if="isInUse" class="icon">이용중</span>
        <span v-if="isUpcoming" class="icon">결제 예약</span>
        <span v-if="isRecommendation" class="icon icon-supplant">추천</span>
      </h3>
      <VoucherButtonShort
        v-if="isShowButton"
        :key="`button__${voucherType}_${quality}`"
        :voucher="voucher"
      >
        <template #short-button>
          <button
            type="button"
            :class="['btn', { selected: isSelected }]"
            @click="$emit('on-click-purchase', voucher?.productid, voucherType)"
          >
            <span>{{ useDay }}</span>
            <span class="won" v-html="amount"></span>
          </button>
        </template>
      </VoucherButtonShort>
    </div>
    <VoucherTableList
      v-if="isPurchaseTable"
      :key="`table__${voucherType}_${quality}`"
      :support-device="supportDevice"
      :quality="quality"
      :concurrency="concurrency"
    />

    <VoucherButtonStandard
      v-if="isShowStandardButton"
      :key="`button__${voucherType}_${quality}_std`"
      :voucher="voucher"
      :voucher-item="voucherItem"
      :selected-product-id="selectedProductId"
      @on-click-purchase="
        $emit('on-click-purchase', $event?.productid, voucherType)
      "
    />
  </div>
</template>
<script setup>
  import { ref, computed, defineProps, defineEmits } from 'vue'
  import VoucherButtonShort from '@/components/lnb/voucher/ui/VoucherButtonShort.vue'
  import VoucherButtonStandard from '@/components/lnb/voucher/ui/VoucherButtonStandard.vue'
  import VoucherTableList from '@/components/lnb/voucher/VoucherTableList.vue'
  import { setNumberComma } from '@/common/util/set-number-comma'

  const props = defineProps({
    voucher: {
      type: Object,
      default: () => {},
      required: true,
    },
    voucherType: {
      type: String,
      default: '',
    },
    selectedProductId: {
      type: String,
      default: '',
    },
  })

  defineEmits(['on-click-purchase'])

  const voucherItem = ref({})

  const isShowButton = computed(() => {
    return (
      props.voucherType !== 'voucher' &&
      props.voucherType !== 'google' &&
      props.voucherType !== 'onestore'
    )
  })
  const isPurchaseTable = computed(() => {
    return props.voucherType !== 'one' && props.voucherType !== 'package'
  })
  const isShowStandardButton = computed(() => {
    return props.voucherType !== 'one' && props.voucherType !== 'package'
  })

  const isUpcoming = computed(() => voucherItem.value.is_upcoming ?? false)
  const isInUse = computed(() => voucherItem.value.in_use ?? false)
  const isRecommendation = computed(
    () => voucherItem.value.recommendation ?? false,
  )
  const isSelected = computed(() => {
    return voucherItem.value?.productid === props.selectedProductId
  })

  const concurrency = computed(
    () => `${voucherItem.value?.concurrency_count}명` ?? '',
  )
  const voucherTitle = computed(() => voucherItem.value?.product_name ?? '')
  const quality = computed(() =>
    voucherItem.value?.quality?.toUpperCase() === 'UHD'
      ? '최고 화질'
      : `${voucherItem.value?.quality} 화질` ?? '',
  )
  const supportDevice = computed(() => voucherItem.value?.support_device ?? '')
  const amount = computed(
    () => `&#65510;${setNumberComma(props.voucher?.amount)}`,
  )
  const useDay = computed(
    () =>
      `${props.voucherType !== 'voucher' ? `${props.voucher?.use_day} / ` : ''}`,
  )

  const init = () => {
    voucherItem.value = props.voucher
  }

  init()
</script>
